module.exports = __webpack_public_path__ + "img/637025819539522717werkende-moeders-overzicht2.png";